import { render } from "./404.vue?vue&type=template&id=6c067b48"
const script = {}
script.render = render

export default script